import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { z } from 'zod';
import { runInBackground } from '@pillar-portal/api-types';

const DateOrStringSchema = z.union([z.instanceof(Date), z.string()]);
const MonetaryAmountSchema = z.union([z.number(), z.string()]);

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string): string {
    const parseResult = DateOrStringSchema.safeParse(date);
    if (!parseResult.success) {
        throw new Error('Invalid date format');
    }
    const d = parseResult.data instanceof Date ? parseResult.data : new Date(parseResult.data);
    return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

export { runInBackground };

export function formatMonetaryAmount(amount: string | number, currencyCode: string = 'USD'): string {
    const parseResult = MonetaryAmountSchema.safeParse(amount);
    if (!parseResult.success) {
        throw new Error(`Invalid monetary amount: ${String(amount)}`);
    }
    const numericAmount: number = Number(parseResult.data);
    if (!Number.isFinite(numericAmount)) {
        throw new Error(`Invalid monetary amount: ${String(amount)}`);
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
    }).format(numericAmount);
}

export function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
